import { UseMutationOptions } from '@tanstack/react-query';

import { usePlaceOrderMutation } from './use-place-order-mutation';
import useGlobalStore from '@/stores/global.store';
import { PaymentMethod } from '@/types/stores/global';

type TData = { paymentId?: string };
type TVariables = { orderId: string; paymentMethod: 'SWISH' | 'PAY_LATER' };

export function usePlaceCurrentOrderMutation(options?: UseMutationOptions<TData, Error, TVariables>) {
  const orderId = useGlobalStore((state) => state.orderId)!;
  const paymentMethod = useGlobalStore((state) => state.paymentMethod);

  const mutation = usePlaceOrderMutation(options);

  return {
    ...mutation,
    mutate: () => mutation.mutate({ orderId, paymentMethod: PaymentMethod.Swish }),
  };
}
